export default __webpack_public_path__ + "static/media/Cote d_Ivoire.bea65047.png";